import { createAction, props, union } from '@ngrx/store';
import { RfrMonSaveQueryI } from 'src/app/api/rfr-mon-save/rfr-mon-save.query.int';

export const load = createAction('[Reefer Monitoring / Save] Get', props<{ query: RfrMonSaveQueryI }>());
export const received = createAction('[Reefer Monitoring / Save] Received', props<Record<string, unknown>>());
export const reset = createAction('[Reefer Monitoring / Save] Reset', props<Record<string, unknown>>());
export const error = createAction('[Reefer Monitoring / Save] Error', props<{ messageText: string }>());

const actions = union({
  error,
  load,
  received,
  reset,
});
export type Actions = typeof actions;
